export const ONE_THOUSAND = 1000;
export const ONE_MILLION = ONE_THOUSAND * 1000;
export const ONE_BILLION = ONE_MILLION * 1000;
export const ONE_TRILLION = ONE_BILLION * 1000;
